import { Component, OnInit } from '@angular/core';
import { ModelRestService } from '../../model-rest.service';
import { SessionService } from '../../session.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Segment } from '../../model/segment';
import { Response } from '../../model/response';
import { RouteBooking } from '../../model/routebooking';
import { WagonType } from '../../model/wagontype';
import { Cost } from '../../model/cost';
import { Url } from 'url';
import { WebPay } from '../../model/webpay';
import { AvailabilityQuery2 } from '../../model/availabilityquery2';
import { Route2 } from '../../model/route2';
/** Inicializa variable para poder usar jquery en componente */
declare var $: any;
declare function PixelShopping(DepartureDate, ReturnDate, DestinationCity, 
  DestinationStateorRegion, DestinationCountry, AttractionName, NumberOfTravelers) : any;
/**Este paso lo unico que hace es mostrar el iframe webpay */
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  
  error:boolean;
  errorMessage:string;
  cargando:boolean=true;

  constructor(private location: Location,
    private model: ModelRestService,
    public session: SessionService,
    private router: Router,
    private sanitizer: DomSanitizer) { }
  /** .*/
  public selected_segment: Segment = null;
  /** .*/
  public selected_wagon_type: WagonType = null;
  /** .*/
  public segments: Segment[] = [];
  /** .*/
  public url: Url;
  /** .*/
  public tabla;
  /** .*/
  public tabla1;
  /** .*/
  public route1;
  /** .*/
  public query;
  /** .*/
  public schedule;
  /** .*/
  public labelClass:string;

  public haveSeniorCitizenBool:boolean;

  public goBack() {
    this.location.back();
  }
  /**Valida que exista un datos en session, si no existe te regresa al paso de reservaciones */
  ngOnInit() {
    if (!this.session || !this.session.route || !this.session.query || !this.session.segments) {
      this.router.navigate(["/reservaciones"]); return;
    }else{
   
      var suma = 0 ;
      this.session.query.passengers.forEach(function (value) {
     
        suma = suma + value;
      });
      var length = this.session.segments.length;
      this.pixel(this.session.segments[0].selected_travel.date,
                 this.session.segments[length-1].selected_travel.date,
                 this.session.segments[length-1].dst.name,
                 this.session.segments[length-1].dst.name,"Mexico",this.session.query.class,suma);
                

    }
    this.haveSeniorCitizenBool = this.haveSeniorCitizen();
    this.labelClass =this.session.query.class.toString();
    this.schedule = this.session.schedule
    this.query = this.session.query
    this.tabla = this.session
    this.tabla1 = this.session.mkUnifiedSegments();
    this.route1 = JSON.parse(sessionStorage.getItem('route'));
    sessionStorage.clear();
    this.session.rb.status = RouteBooking.booked;
    setTimeout(() => {
      this.model.getWebPayUrl(this.session.rb).subscribe((response: Response<WebPay>) => {
        if(response.success)
        {
          this.cargando=false;
          this.url = this.sanitizer.bypassSecurityTrustResourceUrl(response.data.referencia.liga);
          let q2: AvailabilityQuery2;
          this.session.query = q2;
          let r: Route2;
          this.session.route = r;
          let s: Segment[];
          this.session.segments = s;
          this.session = null;
        }
        else{
          this.cargando=false;
          this.error = true;
          this.errorMessage=response.status.message;
        }
      },errorServicio=> {
        this.error = true;      
        this.errorMessage = errorServicio.statusText;
        this.cargando=false;
      });
    }, 1000);
    console.clear();
  }
  /** .*/
  public getCosts(): Cost[] {
    
    var costs = {};
    var costs2: Cost[] = [];
    
    return costs2;
  }
  /** .*/
  public bookIt() {
   
  }
  
  private pixel(DepartureDate, ReturnDate, DestinationCity, 
    DestinationStateorRegion, DestinationCountry, AttractionName, NumberOfTravelers){
     
      var claseStr = "";
      switch (AttractionName) {
        case 6:
          claseStr = "Express Primera";
          break;
        case 5:
          claseStr = "Express Turista";
          break;
        case 4:
          claseStr = "Express Ejecutiva";
          break;
      }

      $("#DepartureDate").val(DepartureDate);
      $("#ReturnDate").val(ReturnDate);
      $("#DestinationCity").val(DestinationCity);
      $("#DestinationStateorRegion").val(DestinationStateorRegion);
      $("#DestinationCountry").val(DestinationCountry);
      $("#claseStr").val(claseStr);
      $("#NumberOfTravelers").val(NumberOfTravelers);

      PixelShopping(DepartureDate, ReturnDate, DestinationCity, 
      DestinationStateorRegion, DestinationCountry, claseStr, NumberOfTravelers);

  }
  
  public haveSeniorCitizen(){

    //console.log(this.session.query.passengers[3]);
    var totalSenior = this.session.query.passengers[3];

    if(totalSenior>0)
    {
      return true;
    }else
    {
      return false;
    }

  }
}
